// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2IwqW","buttons":"Footer_buttons__L9cFp"};